import { Card, Row, Col, Space, Skeleton } from "antd"
import { useSelector } from "react-redux"
import { Text, Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { formatPhoneNumber } from "utils/data-formatters"
import moment from "moment"
const ClientStatsCard = () => {
  const client = useSelector((state) => state.clients.client)
  const { total_booking_amount, total_bookings_count, loading, user } = client || {}
  const { phone_number, email, full_address, gender, birthday } = user || {}
  const { t } = useTranslation()

  return (
    <Card>
      <Row gutter={[0, 24]}>
        <Col xs={24}>
          <Title level={5}>{t("client.statistics")}</Title>

          <Space direction="vertical" size={4} className="mt-m w-full">
            <Skeleton loading={loading} active paragraph={{ rows: 0 }}>
              <Row>
                <Col span={11}>
                  <Text>{t("client.total_number_of_bookings")}</Text>
                </Col>
                <Col span={12} offset={1}>
                  <Text>{total_bookings_count}</Text>
                </Col>
              </Row>
            </Skeleton>
            <Skeleton loading={loading} active paragraph={{ rows: 0 }}>
              {total_booking_amount && (
                <Row>
                  <Col span={11}>
                    <Text>{t("client.total_amount_spent")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{total_booking_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</Text>
                  </Col>
                </Row>
              )}
            </Skeleton>
          </Space>
        </Col>
        <Col xs={24}>
          <Title level={5}>{t("client.client_details")}</Title>
          <Skeleton loading={loading} active paragraph={{ rows: 3 }}>
            <Space direction="vertical" size={4} className="mt-m w-full">
              {phone_number && (
                <Row>
                  <Col span={11}>
                    <Text>{t("client.phone")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{formatPhoneNumber(phone_number)}</Text>
                  </Col>
                </Row>
              )}
              {email && (
                <Row>
                  <Col span={11}>
                    <Text>{t("global.email")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{email}</Text>
                  </Col>
                </Row>
              )}
              {full_address && (
                <Row>
                  <Col span={11}>
                    <Text>{t("client.address")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{full_address}</Text>
                  </Col>
                </Row>
              )}
              {gender && (
                <Row>
                  <Col span={11}>
                    <Text>{t("client.gender")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{gender}</Text>
                  </Col>
                </Row>
              )}
              {birthday && (
                <Row>
                  <Col span={11}>
                    <Text>{t("client.birthday")}</Text>
                  </Col>
                  <Col span={12} offset={1}>
                    <Text>{moment(birthday)?.format("MM/DD/YYYY")}</Text>
                  </Col>
                </Row>
              )}
            </Space>
          </Skeleton>
        </Col>
      </Row>
    </Card>
  )
}

export default ClientStatsCard
